import React from 'react';
import Login from '../features/login/Login';
import Users from '../features/User/Users';

import PageNotFound from '../features/pageNotFound';

import PublicRoute from './PublicRoute';
import ProtectedRoute from './ProtectedRoute';

import OuterLayout from '../layout/OuterLayout';
import InnerLayout from '../layout/InnerLayout';

import { Route, Routes } from 'react-router-dom';
import Payment from '../features/payment/Payments';
import Numbers from '../features/Numbers/Numbers';
import Bundle from '../features/Bundle/Bundle';
import Plans from '../features/Plans/Plans';
import CallHistory from '../features/History/Call';
import BundleHistory from '../features/History/Bundle';
import PaymentHistory from '../features/History/Payment';
import Call from '../features/Rates/Call';
import Sms from '../features/Rates/Sms';
import Providers from '../features/Providers/Providers';
import Bought from '../features/Numbers/Bought';
import Ported from '../features/Numbers/Ported';

import Refund from '../features/History/Refund';
import Settings from '../features/settings';
import FranceDID from '../features/Numbers/FranceDID';
import RequestFrance from '../features/Numbers/RequestFrance';
import DIDCountry from '../features/DIDCountry';

import LiveUsers from '../features/User/LiveUsers';
import LiveNumber from '../features/Numbers/LiveVnNumber/LiveNumber';
import ExternalPaymentList from '../features/ExternalPaymentList';
import SmsHistory from '../features/History/Sms';
import BundleCall from '../features/Bundle/BundleCall';
import BundleSMS from '../features/Bundle/BundleSMS';
import BundleVN from '../features/Bundle/BundleVN';
import ExpiredVN from '../features/Numbers/ExpiredVN';
import FailedPayments from '../features/payment/FailedPayments';
import BlockList from '../features/BlockList';
import ReRoute from '../features/ReRoute';

const Router = () => {
  const protectedRoute = [
    {
      id: '1',
      path: '/user',
      element: <Users />,
    },
    {
      id: '2',
      path: '/payment',
      element: <Payment />,
    },
    {
      id: '25',
      path: '/failed-payment',
      element: <FailedPayments />,
    },
    {
      id: '3',
      path: '/numbers/DIDs',
      element: <Numbers />,
    },
    {
      id: '4',
      path: '/bundle/call',
      element: <BundleCall />,
    },
    {
      id: '5',
      path: '/plans',
      element: <Plans />,
    },
    {
      id: '6',
      path: '/history/call',
      element: <CallHistory />,
    },
    {
      id: '7',
      path: '/history/bundle',
      element: <BundleHistory />,
    },
    {
      id: '8',
      path: '/history/payment',
      element: <PaymentHistory />,
    },
    {
      id: '9',
      path: '/rates/call',
      element: <Call />,
    },
    {
      id: '10',
      path: '/rates/sms',
      element: <Sms />,
    },
    {
      id: '11',
      path: '/providers',
      element: <Providers />,
    },
    {
      id: '12',
      path: '/numbers/bought',
      element: <Bought />,
    },
    {
      id: '13',
      path: '/numbers/ported',
      element: <Ported />,
    },
    {
      id: '14',
      path: '/numbers/stock',
      element: <FranceDID />,
    },
    {
      id: '15',
      path: '/numbers/requested',
      element: <RequestFrance />,
    },
    {
      id: '16',
      path: '/history/refund',
      element: <Refund />,
    },
    {
      id: '17',
      path: '/settings',
      element: <Settings />,
    },
    {
      id: '18',
      path: '/live/users',
      element: <LiveUsers />,
    },
    {
      id: '19',
      path: '/live/number',
      element: <LiveNumber />,
    },
    {
      id: '20',
      path: '/numbers/add-country',
      element: <DIDCountry />,
    },
    {
      id: '20',
      path: '/external-payment-list',
      element: <ExternalPaymentList />,
    },
    {
      id: '21',
      path: '/history/sms',
      element: <SmsHistory />,
    },
    {
      id: '22',
      path: '/bundle/sms',
      element: <BundleSMS />,
    },
    {
      id: '23',
      path: '/bundle/vn',
      element: <BundleVN />,
    },
    {
      id: '24',
      path: '/numbers/expired-vn',
      element: <ExpiredVN />,
    },
    {
      id: '25',
      path: '/re-route',
      element: <ReRoute />,
    },
    {
      id: '26',
      path: '/block-list',
      element: <BlockList />,
    },
  ];
  return (
    <Routes>
      <Route element={<ProtectedRoute />}>
        <Route element={<InnerLayout />}>
          {protectedRoute.map((route) => {
            return (
              <Route key={route.id} path={route.path} element={route.element} />
            );
          })}
        </Route>
      </Route>
      <Route element={<PublicRoute />}>
        <Route element={<OuterLayout />}>
          <Route path="/" element={<Login />} />
        </Route>
      </Route>
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default Router;
